/*!
 * Copyright (c) 2015-2020 Cisco Systems, Inc. See LICENSE file.
 */
import '@webex/internal-plugin-device';
import '@webex/internal-plugin-feature';
import '@webex/internal-plugin-metrics';
import MobiusSocket from './mobius-socket';
import config from './config';
let mobiusSocketInstance;
export function getMobiusSocketInstance(webex, mobiusSocketConfig) {
    if (mobiusSocketInstance) {
        return mobiusSocketInstance;
    }
    mobiusSocketInstance = new MobiusSocket(webex, {
        ...config.mobiusSocket,
        ...mobiusSocketConfig,
    });
    return mobiusSocketInstance;
}
export function resetMobiusSocketInstance() {
    mobiusSocketInstance = undefined;
}
export default MobiusSocket;
export { MobiusSocket };
